import React, { useState } from 'react'
import { triangle } from '../../Images/Icons'

const ConsumptionSection = (props) => {
    const [state, setNewState] = useState({
        showPoup: false,
    });
    
    const SelfSuff = parseFloat(props.state.SelfSuff.toFixed(2))
    const FromGrid = parseFloat(props.state.FromGrid.toFixed(2))
    const totalConsumption = SelfSuff + FromGrid
    const persenSelfSuff = (SelfSuff / totalConsumption) * 100
    const persenFromGrid = (FromGrid / totalConsumption) * 100
    const formattedpersenSelfSuff = isNaN(persenSelfSuff) ? 0 : persenSelfSuff.toFixed(2);
    const formattedPersenFromGrid = isNaN(persenFromGrid) ? 0 : persenFromGrid.toFixed(2);

    const setState = data => {
        setNewState(prev => ({ ...prev, ...data }))
    }

    const showPopupConsumption = () => {
        setState({ showPoup: true });
        setTimeout(() => {
            setState({ showPoup: false });
        }, 3000);
    }

    const renderDonut = (self, grid) => {
        const total = self + grid;
        const selfPercent = (100 * (self / total));
        const gridPercent = (100 * (grid / total));

        return (<div className="" style={{ position: 'absolute', top: -14, border: 'none 1px', width: 100, height: 100, background: 'white', borderRadius: '50%' }}>
            <svg width="100%" height="100%" viewBox="0 0 40 40" >
                <circle cx="20" cy="20" r="16" fill="transparent" stroke='#FFB31E' strokeWidth="3.5" strokeDasharray={`${gridPercent} ${selfPercent}`} strokeDashoffset={25} strokeLinecap='round'></circle>
                <circle cx="20" cy="20" r="16" fill="transparent" stroke='#EE7D03' strokeWidth="3.5" strokeDasharray={`${selfPercent} ${gridPercent}`} strokeDashoffset={((100-gridPercent)+25)} strokeLinecap='round'></circle>
                <g>
                    <text y="50%">
                        <tspan x="50%" textAnchor="middle" style={{ fontSize: '0.4em', fill: '#292929', fontWeight: 500 }}>{total.toFixed(2)}</tspan>
                    </text>
                    <text y="68%">
                        <tspan x="50%" textAnchor="middle" className='donut-subtitle' style={{ fill: '#6a6a6a', fontSize: '0.3em', fontWeight: 500 }}>kWh</tspan>
                    </text>
                </g>
            </svg>
        </div>);
    }

    const { showPoup } = state;

    return (
        <div style={{ position: 'relative' }}>
            <div style={{ height: 20, display: 'flex', justifyContent: 'end', alignItems: 'center', marginTop: 20, marginBottom: -14, fontSize: 12, fontWeight: 500, color: '#5E677B' }}>
                Consumption <span onClick={showPopupConsumption} className='fi fi-rr-info' style={{ marginLeft: 4, lineHeight: 0.8, fontSize: 14, cursor: 'pointer' }}></span>
            </div>
            <div style={{ height: 71, marginTop: 20, background: '#F6F8FB', borderRadius: 12, position: 'relative', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#EE7D03', fontSize: 16, fontWeight: 500 }}>
                        <span>{SelfSuff}</span> <span style={{ color: '#79808F', fontSize: 10, fontWeight: 500, marginLeft: 4 }}>kWh</span>
                    </div>
                    <div style={{ color: '#79808F', fontSize: 10, fontWeight: 500, marginTop: -4 }}>
                        Self-sufficiency
                    </div>
                    <div style={{ color: '#79808F', fontSize: 10, fontWeight: 500 }}>
                        ({formattedpersenSelfSuff}%)
                    </div>
                </div>
                <div style={{ flex: 1, height: 71, border: 'none 1px', display: 'flex', justifyContent: 'center', position: 'relative' }}>
                    {renderDonut(SelfSuff, FromGrid)}
                </div>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#FFB31E', fontSize: 16, fontWeight: 500 }}>
                        <span>{FromGrid}</span> <span style={{ color: '#79808F', fontSize: 10, fontWeight: 500, marginLeft: 4 }}>kWh</span>
                    </div>
                    <div style={{ color: '#79808F', fontSize: 10, fontWeight: 500, marginTop: -4 }}>
                        from grid
                    </div>
                    <div style={{ color: '#79808F', fontSize: 10, fontWeight: 500 }}>
                        ({formattedPersenFromGrid}%)
                    </div>
                </div>
            </div>
            {/**Tooltip */}
            {showPoup && <>
                <div style={{
                    width: 300, height: 160, position: 'absolute', top: 30, right: -24, background: '#2C313A', borderRadius: 12, zIndex: 1000,
                    fontSize: 12, fontWeight: 400, color: '#FAFAFA', padding: 12
                }}>
                    From PV<br />
                    <p>Amount of consumed electricity provided by PV, including the surplus storage devices.</p>

                    From grid:<br />
                    <p>Amount of power purchased from the grid in a given reporting period.</p>
                </div>
                <div style={{ position: 'absolute', top: 15, right: -12 }}><img src={triangle} alt="" style={{ width: 36, height: 24 }} /></div>
            </>}
        </div>
    )
}

export default ConsumptionSection